import Driver from "../components/Inventory-Stocks & Orders/Clinic/Driver/Driver";

export const AddNewDeliveryAgentModal: React.FC<{ onClose: () => void, driverType: string }> = ({ onClose, driverType }) => {
  return (
    <section className="absolute inset-0 z-50" style={{ height: "100vh" }}>
       <Driver onClose={onClose} driverType={driverType} />
    </section>
  );
}
